// extracted by mini-css-extract-plugin
export var faqHeadText = "faqSection-module--faqHeadText--0InS5";